import React from 'react';

// Stroke icons (24×24) used across the install UI and the landing-page tiles.
const PATHS = {
  share: 'M12 3v12m0-12l-4 4m4-4l4 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7',
  addSquare: 'M12 8v8m-4-4h8M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2z',
  check: 'M5 13l4 4L19 7',
  menu: 'M12 5h.01M12 12h.01M12 19h.01',
  dots: 'M5 12h.01M12 12h.01M19 12h.01',
  download: 'M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4',
  monitorDown: 'M3 4h18v12H3zM8 20h8M12 16v4M12 7v5m-2-2l2 2 2-2',
  external: 'M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5',
  phone: 'M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z',
  bolt: 'M13 2L4 14h7l-1 8 9-12h-7l1-8z',
  refresh: 'M4 4v5h5M20 20v-5h-5M5.5 15a7 7 0 0011.9 2.5M18.5 9A7 7 0 006.6 6.5',
  devices: 'M4 5h12v9H4zM2 18h16M18 8h3a1 1 0 011 1v10a1 1 0 01-1 1h-3a1 1 0 01-1-1V9a1 1 0 011-1z',
  bell: 'M15 17h5l-1.4-1.4A2 2 0 0118 14.2V11a6 6 0 00-4-5.7V5a2 2 0 10-4 0v.3C7.7 6.2 6 8.4 6 11v3.2c0 .5-.2 1-.6 1.4L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9',
  feather: 'M20 4C12 4 6 10 6 18M6 18l-2 2M6 18h7a7 7 0 007-7V4',
  ticket: 'M3 8a2 2 0 002-2h14a2 2 0 002 2v2a2 2 0 000 4v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a2 2 0 000-4V8zM14 6v12',
  qr: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2M14 18h2v2M18 18h2v2',
  calendar: 'M8 3v4m8-4v4M4 9h16M5 5h14a1 1 0 011 1v14a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1zM8 13h3v3H8z',
  gift: 'M4 11h16v10H4zM2 7h20v4H2zM12 7v14M12 7S10.5 3 8 3a2 2 0 000 4h4zm0 0s1.5-4 4-4a2 2 0 010 4h-4z',
  chat: 'M21 12a8 8 0 01-11.6 7.1L4 20l1-4.6A8 8 0 1121 12zM8 11h.01M12 11h.01M16 11h.01',
  tasks: 'M9 6h11M9 12h11M9 18h11M4 6l1 1 2-2M4 12l1 1 2-2M4 18l1 1 2-2',
  image: 'M4 5h16v14H4zM4 16l5-5 4 4 2-2 5 5M15 9h.01',
  users: 'M16 20v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2M9 10a4 4 0 100-8 4 4 0 000 8zM22 20v-2a4 4 0 00-3-3.9M16 2.1a4 4 0 010 7.8',
  lock: 'M6 11h12v10H6zM8 11V7a4 4 0 118 0v4',
  card: 'M3 6h18v12H3zM3 10h18M7 15h3',
  shield: 'M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-4zM9 12l2 2 4-4',
  globe: 'M12 21a9 9 0 100-18 9 9 0 000 18zM3 12h18M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9s1-6.5 3.5-9z',
  arrowRight: 'M13 7l5 5m0 0l-5 5m5-5H6',
  close: 'M6 18L18 6M6 6l12 12',
  chevronDown: 'M6 9l6 6 6-6',
  copy: 'M8 8h12v12H8zM4 16V4h12',
};

export default function InstallIcon({ name, className, strokeWidth = 2 }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true" focusable="false">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={name === 'menu' || name === 'dots' ? 3.5 : strokeWidth}
        d={PATHS[name] || PATHS.download}
      />
    </svg>
  );
}
